export interface Props {
    tags?: string[]
}

const TagList = (props: Props) => {
    const tags = props.tags || [];

    return (
        <div className="flex flex-wrap gap-1">
            {tags.map(t => (
                <span key={t} className="inline-flex items-center px-1.5 py-px rounded text-[10.5px] font-medium bg-accent-soft text-accent">
                    {t}
                </span>
            ))}
        </div>
    );
};

export default TagList;
